import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../utility';

const initialState = {
    timezone: null,
    weekSchedule: {
        timezone: 'LA/Los Angeles',
        days: {
            monday: null,
            tuesday: null,
            wenesday: null,
            thursday: null,
            friday: null, 
            saturday: null,
            sunday: null,
        }
    },
};

const settingGet = ( state, action ) => {
    return updateObject( state, 
        { 
            weekSchedule: action.weekSchedule,
        }
    );
};

const reducer = ( state = initialState, action ) => {
    switch ( action.type ) {
        case actionTypes.SETTING_GET: return settingGet(state, action);
        default:
            return state;
    }
};

export default reducer;


// WEBPACK FOOTER //
// ./src/store/reducers/setting.js